module.exports = __webpack_public_path__ + "img/check_2.5924203a.svg";